import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "order-table-preview grid-1" }
const _hoisted_2 = { class: "flex space-x-4 overflow-hidden" }
const _hoisted_3 = { class: "w-96 space-y-4" }
const _hoisted_4 = { class: "preview-table-details" }
const _hoisted_5 = { class: "flex items-center" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "flex-grow basis-0 overflow-hidden space-y-4" }
const _hoisted_8 = { class: "font-bold" }
const _hoisted_9 = {
  key: 0,
  class: "text-dark-muted text-sm"
}
const _hoisted_10 = { class: "text-black" }

import { RepairOrderClosedResource } from '@shared/resources/repair-order';
import { coinsFormat } from '@shared/helpers/data-converters/number-converters';
import { timestampToDate } from '@/helpers/datetime';
import ClientBadge from '@/pages/partials/ClientBadge.vue';
import PreviewTable from './PreviewTable.vue';
import SelectPrintNew from '../SelectPrintNew.vue';
import Button from '@ui-kit/controls/button/Button.vue';
import { useModalsStore } from '@/stores/modals';
import ModalConfirmation from '@components/modals/ModalConfirmation.vue';
import { useI18n } from 'vue-i18n';
import { START_DOCUMENT_NUMBER } from '@components/print/constants';
import { OrderService } from '@/services/order.service';

interface Props {
  data: RepairOrderClosedResource,
}
interface Emits {
  (e: 'update'): void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'OrderTablePreviewNew',
  props: {
    data: null
  },
  emits: ["update"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  data: RepairOrderClosedResource,
}





const ordersService = new OrderService();
const modalsStore = useModalsStore();
const { t } = useI18n();

function closeOrder() {
  modalsStore.addModal({
    component: ModalConfirmation,
    props: {
      title: t('pages.orders.remove-label'),
      description: t('pages.orders.remove-closed-description'),
      message: t('pages.orders.remove-closed-message', {
        orderNumber: props.data.id + START_DOCUMENT_NUMBER,
        orderClient: props.data.client.name,
      }),
      danger: true,
      confirmationDisableTime: 5,
      confirmText: t('common.actions.delete'),
      confirm: async () => {
        await ordersService.removeClosed(props.data.id).send();
        emit('update');
      },
    },
  });
}

return (_ctx: any,_cache: any) => {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("table", _hoisted_4, [
          _createElementVNode("tr", null, [
            _createElementVNode("td", null, _toDisplayString(_ctx.$t('fields.date')) + ":", 1),
            _createElementVNode("td", null, _toDisplayString(_unref(timestampToDate)(__props.data.date)), 1)
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", null, _toDisplayString(_ctx.$t('fields.client')) + ":", 1),
            _createElementVNode("td", null, [
              _createElementVNode("div", _hoisted_5, [
                _createTextVNode(_toDisplayString(__props.data.client.name) + " ", 1),
                _createVNode(ClientBadge, {
                  class: "ml-2",
                  type: __props.data.client.clientType
                }, null, 8, ["type"])
              ])
            ])
          ]),
          (__props.data.carName)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_6, [
                _createElementVNode("td", null, _toDisplayString(_ctx.$t('fields.car')) + ":", 1),
                _createElementVNode("td", null, _toDisplayString(__props.data.carName) + " " + _toDisplayString(__props.data.carRegistrationPlate), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(SelectPrintNew, {
          class: "w-4/5",
          data: __props.data
        }, null, 8, ["data"]),
        _createElementVNode("div", null, [
          _createVNode(Button, {
            color: "danger",
            class: "w-4/5",
            "button-type": "outline",
            onClick: closeOrder
          }, {
            default: _withCtx(() => [
              _createVNode(_component_FontAwesomeIcon, {
                icon: "trash",
                class: "mr-2"
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('common.actions.delete')), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(PreviewTable, { order: __props.data }, null, 8, ["order"]),
        _createElementVNode("div", null, [
          _createTextVNode(_toDisplayString(_ctx.$t('fields.sum_local')) + ": ", 1),
          _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(coinsFormat)(__props.data.sum)), 1)
        ])
      ])
    ]),
    (__props.data.notes)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('fields.notes')) + ":", 1),
          _createElementVNode("div", null, _toDisplayString(__props.data.notes), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})